import { useForm } from "react-hook-form";
import { JVDropdown } from "../../shared/JVDropdown";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { EmptyPipFilter, TPipFilter } from "./modal";
import { TDropdown } from "../../shared/modal";
import { Fetch } from "../../utilities/fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDate } from "../../shared/JVDate";

interface IProps {
    filters: TPipFilter,
    setFilters: (filters: TPipFilter) => void,
    loading: boolean,
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    requirementId: yup.number().nullable(),
    skillCategoryId: yup.number().nullable(),
    salesId: yup.number().nullable(),
    recruiterId: yup.number().nullable()
});

export const Filter = (props: IProps) => {
    const [skillCategories, setSkillCategories] = useState<Array<TDropdown>>();
    const [sales, setSales] = useState<Array<TDropdown>>();
    const [recruiter, setRecruiter] = useState<Array<TDropdown>>();

    const { control, handleSubmit, reset } = useForm<TPipFilter>({
        resolver: yupResolver(schema),
        defaultValues: props.filters,
        shouldFocusError: false
    });

    const loadSkillCategories = async () => {
        const data = await Fetch<TDropdown[]>("dropdown/skillCategories");
        if (data) {
            setSkillCategories(data);
        }
    }
    const loadSales = async () => {
        const data = await Fetch<TDropdown[]>("pipeline/sales");
        if (data) {
            setSales(data);
        }
    }
    const loadRecruiters = async () => {
        const data = await Fetch<TDropdown[]>("pipeline/recruiter");
        if (data) {
            setRecruiter(data);
        }
    }

    useEffect(() => {
        loadSkillCategories();
        loadSales();
        loadRecruiters();
    }, []);

    const onSubmit = (data: TPipFilter) => {
        props.setFilters(data);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
            <JVDate column={4} label="From Date" control={control} name="fromDate" />
            <JVDate column={4} label="To Date" control={control} name="toDate" />
            <JVInput column={4} type="number" label="Req Id" control={control} name="requirementId" />

            <JVDropdown column={4} required label="Skill Category" control={control} name="skillCategoryId"
                options={skillCategories} optionLabel="name" optionValue="id" placeholder="Select skill category" />

            <JVDropdown column={4} required label="Sales" control={control} name="salesId"
                options={sales} optionLabel="name" optionValue="id" placeholder="Select sales manager" />

            <JVDropdown column={4} required label="Recruiter" control={control} name="recruiterId"
                options={recruiter} optionLabel="name" optionValue="id" placeholder="Select recruiter" />

            <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                <Button className="field col-12 md:col-6" label="SEARCH" type="submit" loading={props.loading}></Button>
                <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={() => reset(EmptyPipFilter)} type="button"></Button>
            </div>
        </form>
    );
}